module.exports = __webpack_public_path__ + "img/public/siteImages/yourCars.svg?f9c6723a";